export default "__VITE_ASSET__x3S3X3Kt__"